import script from "./StudentList.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentList.vue?vue&type=script&setup=true&lang=js"

import "./StudentList.vue?vue&type=style&index=0&id=05315e9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05315e9d"]])

export default __exports__